export default "__VITE_ASSET__Brvw4lHz__"